import { render } from "./OrganisationTabs.vue?vue&type=template&id=2a7028b6"
import script from "./OrganisationTabs.vue?vue&type=script&lang=js"
export * from "./OrganisationTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__